import { Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { formatDepositCurrencyAmount } from '../../../../../../utils/depositInvoices/formatDepositCurrencyAmount'
import { useDepositInvoiceForm } from '../../../../contexts/depositInvoiceDetailsFormContext'
import { useDepositInvoiceDetailsModal } from '../../../../contexts/depositInvoiceDetailsModalContext'
import * as Styled from './styles'

export const DepositInvoiceDetailsMultiVatTable = (): ReactElement => {
  const { t } = useTranslation()
  const { quoteLocale, quoteCurrency } = useDepositInvoiceDetailsModal()
  const { vatLines, remainingBalance } = useDepositInvoiceForm()

  const getVatRowTitle = (percentage: number) => {
    if (vatLines.length > 1) {
      return t('external_invoices.deposit_invoice_details_modal.deposit_total_excl_vat_with_percentage', {
        percentage,
      })
    }
    return t('external_invoices.deposit_invoice_details_modal.deposit_total_excl_vat')
  }

  return (
    <Flex flexDirection="column">
      <Styled.DepositTotalRowWrapper>
        <Flex flexDirection="column" gap={Spacing.S12}>
          {vatLines.map((item) => (
            <Flex key={item.vatRateId} justifyContent="space-between">
              <Text variant="bodyMD" weight="semiBold">
                {getVatRowTitle(item.percentage)}
              </Text>
              <Text variant="bodyMD" weight="semiBold">
                {formatDepositCurrencyAmount(item.depositAmountForVatItem, quoteCurrency, quoteLocale)}
              </Text>
            </Flex>
          ))}
        </Flex>
      </Styled.DepositTotalRowWrapper>

      <Styled.DepositRemainingRowWrapper>
        <Flex justifyContent="space-between">
          <Text variant="bodyMD" weight="regular">
            {t('external_invoices.deposit_invoice_details_modal.remaining_balance_excl_vat')}
          </Text>
          <Text variant="bodyMD" weight="regular">
            {formatDepositCurrencyAmount(remainingBalance, quoteCurrency, quoteLocale)}
          </Text>
        </Flex>
      </Styled.DepositRemainingRowWrapper>
    </Flex>
  )
}
